export default "__VITE_ASSET__D1vRimU4__"